"use strict";
/// <reference path="Favorites.d.ts" />
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavoriteData = void 0;
const tslib_1 = require("tslib");
let _ = require("underscore");
require("@progress/kendo-ui");
require("babel-polyfill");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
require("jquery-address");
const MethodManager_1 = require("../../../../TdWebtoolkitControls/controls/Menu/MethodManager");
require("../../../../TdWebtoolkitControls/controls/PropertyPage/PropertyPageControls");
const Utilities_1 = require("../../../../TdWebtoolkitControls/javascript/Utilities");
require("./Favorites.less");
const $ = require("jquery");
const Instance_1 = require("../../../../TdWebtoolkitControls/model/Instance");
class FavoriteData {
    constructor(version, data) {
        this.version = version;
        this.data = data;
    }
}
exports.FavoriteData = FavoriteData;
class FavoriteModel extends kendo.data.ObservableObject {
    constructor() {
        super();
        this.instance = undefined; // Favorite-Objekt in der Datenbank. Im Content dieses Objektes befinden sich die eigentlichen Filterangaben dieses Favoriten im "alten" JSON-Format
        this.readOnly = false;
        this._unsavedChanges = undefined; // hier liegen die ungespeicherten Änderungen des Favoriten im "alten" JSON-Format vor.
    }
    ;
}
class Favorites {
    static init($elem, options) {
        return $elem.each(function () {
            let $this = $(this);
            let synData = $this.data("synFavorites");
            if (!synData) {
                $this.data("synFavorites", $.extend({
                    viewName: undefined,
                    readOnly: false,
                    compact: true,
                    showFavoriteSelectedNotification: true,
                    initiallySelectedId: undefined
                }, options));
                synData = $this.data("synFavorites");
                synData.maxNameLength = 0;
                $this.trigger("beginInit");
                $this.addClass("synFavorites");
                if (!synData.viewName) {
                    $.errorDialog({ ErrorDisplayMessage: "Must specify view name" });
                    $this.trigger("initFailed");
                }
                else
                    Favorites.InitCore($this, synData);
                $this.trigger("endInit");
            }
        });
    }
    static destroy($elem) {
        return $elem.each(function () {
            $(this).off("beginInit")
                .off("categoriesReceived")
                .off("initSuccess")
                .off("initFailed")
                .off("endInit")
                .off("favoriteSelected")
                .removeData("synFavorites");
        });
    }
    static updateFavorite($elem, favorite) {
        return $elem.each(function () {
            let $this = $(this);
            let synData = $this.data("synFavorites");
            let listView = $this.find(".favListView").data("kendoListView");
            let favModel = listView.dataItem(listView.select());
            if (favModel && !synData.readOnly && !favModel.instance.items["cefavorite.adminfavorite"].value && !favModel.instance.items["cefavorite.isdefault"].value) {
                favModel._unsavedChanges = favorite;
                Favorites.refreshAndKeepSelection($this);
            }
        });
    }
    static clearSelection($elem) {
        return $elem.each(function () {
            let $this = $(this);
            let listView = $this.find(".favListView").data("kendoListView");
            if (listView.dataSource.data().length) {
                Favorites.RemoveUnsavedChanges($this);
                listView.clearSelection();
            }
            Favorites.UpdateStar($this);
        });
    }
    static selectFavorite($elem, favoriteId) {
        return $elem.each(function () {
            Favorites.trySelectFavorite($(this), favoriteId);
        });
    }
    static trySelectDefaultFavorite($elem) {
        const listView = $elem.find(".favListView").data("kendoListView");
        const data = listView.dataSource.data();
        let id;
        for (let i = 0; i < data.length; ++i) {
            let favModel = data[i];
            if (favModel.instance.items["cefavorite.isdefault"].value) {
                id = favModel.instance.id.value;
                break;
            }
        }
        return Favorites.trySelectFavorite($elem, id);
    }
    static trySelectFavorite($elem, favoriteId) {
        if (!favoriteId)
            return false;
        let success = false;
        let listView = $elem.find(".favListView").data("kendoListView");
        let data = listView.dataSource.data();
        if (data.length) {
            Favorites.RemoveUnsavedChanges($elem);
            let idx = -1;
            for (let i = 0; i < data.length; ++i) {
                if (data[i].id.value === favoriteId) {
                    idx = i;
                    success = true;
                    break;
                }
            }
            if (idx >= 0)
                listView.select($(listView.element.children()[idx]));
        }
        Favorites.UpdateStar($elem);
        return success;
    }
    static getSelectedFavoriteAsync($elem) {
        return new Promise((resolve, reject) => {
            let listView = $elem.find(".favListView").data("kendoListView");
            let dataItem = listView.dataItem(listView.select());
            if (dataItem)
                Favorites.GetJSON(dataItem.id.value, resolve);
            else
                resolve(undefined);
        });
    }
    static getSelectedFavoriteId($elem) {
        let listView = $elem.find(".favListView").data("kendoListView");
        let dataItem = listView.dataItem(listView.select());
        return dataItem ? dataItem.id.value : undefined;
    }
    //#region Helpers
    static refreshAndKeepSelection($this) {
        let listView = $this.find(".favListView").data("kendoListView");
        let selectedIndex = listView.select().index();
        $this.data("ignoreChangeEvent", true);
        listView.refresh();
        if (selectedIndex >= 0)
            listView.select($(listView.element.children()[selectedIndex]));
        Favorites.UpdateStar($this);
        $this.data("ignoreChangeEvent", false);
    }
    static InitCore($this, options) {
        let saveIconUrl = Utilities_1.synUtil.getWSUrl("Icon") + "method=menusaveinclshorcut/24";
        let editIconUrl = Utilities_1.synUtil.getWSUrl("Icon") + "method=cefunc.29/24";
        let newIconUrl = Utilities_1.synUtil.getWSUrl("Icon") + "method=cefunc.111/16";
        let synData = $this.data("synFavorites");
        let itemTemplate = "# let _allowWrite = !readOnly && !data.instance.items[\"cefavorite.adminfavorite\"].value && !data.instance.items[\"cefavorite.isdefault\"].value; #"
            + "<div class='favorite' data-id='#=data.instance.id.valueAsString#'># if (_allowWrite) { # "
            + "    <a class='delLink' href='javascript:void(0)'><i class='del fa fa-times'></i></a>"
            + "    <a class='saveLink' href='javascript:void(0)'><img src='" + saveIconUrl + "' # if (data._unsavedChanges==undefined) { # style='visibility: hidden' # } # class='save' /></a>"
            + "    <a class='writeLink' href='javascript:void(0)'><img src='" + editIconUrl + "' class='edit' /></i></a>"
            + "# }"
            + "else if(!readOnly){ # <span class='spacer' /> # } #"
            + "<div class='wrapper'>"
            + "<a class='name #if(data.instance.items[\"cefavorite.isdefault\"].value){# default #}#' href='javascript:void(0)'>#: data.instance.name.valueAsString #</a>"
            + "</div>"
            + "</div>";
        let $listViewTarget = $();
        if (options.compact) {
            $this.addClass("compact");
            let $ulOuter = $("<ul class='favMenu'></ul>").appendTo($this);
            let $liOuter = $("<li><i class='menuStar fa fa-star-o'></i></li > ").appendTo($ulOuter);
            let $ulInner = $("<ul class='innerMenu'></ul>").appendTo($liOuter);
            let $liInner = $("<li></li>").appendTo($ulInner);
            $listViewTarget = $("<div class='favListView' style='overflow: auto'></div>").appendTo($liInner);
            $ulOuter
                .kendoMenu({
                animation: false,
                direction: "right",
                openOnClick: {
                    rootMenuItems: true,
                    subMenuItems: false
                },
                close(e) {
                    if ($ulOuter.hasClass("noClose"))
                        e.preventDefault();
                }
            });
        }
        else
            $listViewTarget = $("<div class='favListView'></div>").appendTo($this);
        let dataSource = new kendo.data.DataSource({
            transport: {
                read(opts) {
                    Utilities_1.synUtil.getAJAXData({
                        url: Utilities_1.synUtil.getWSUrl("ProfileFavorites") + options.viewName,
                        done(favInfo) {
                            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                let synData = $this.data("synFavorites");
                                synData.maxNameLength = favInfo.maxNameLength;
                                let favModels = [];
                                for (let xFav = 0; xFav < favInfo.favorites.length; xFav++) {
                                    let favMode = new FavoriteModel();
                                    favMode.readOnly = options.readOnly;
                                    favMode.instance = yield Instance_1.Instance.fromJSON(favInfo.favorites[xFav]);
                                    favModels.push(favMode);
                                }
                                favModels.sort((a, b) => {
                                    let sortNumDefault = (favModel) => (favModel.instance.items["cefavorite.isdefault"].value ? 100 : 0);
                                    let sortNumAdmin = (favModel) => (favModel.instance.items["cefavorite.adminfavorite"].value ? 10 : 0);
                                    return sortNumDefault(b) + sortNumAdmin(b) - sortNumDefault(a) - sortNumAdmin(a) + a.instance.name.valueAsString.localeCompare(b.instance.name.valueAsString);
                                });
                                opts.success(favModels);
                            });
                        }
                    });
                }
            }
        });
        let $buttonBar = $("<div class='buttonBar'></div>").insertBefore($listViewTarget);
        $("<div class='favHeader'></div>")
            .text(Utilities_1.synUtil.Strings.getValue("menufavorites"))
            .appendTo($buttonBar);
        if (!options.readOnly) {
            let $newFavButton = $("<button type='button' class='newFavButton btn btn-default'></button>").appendTo($buttonBar);
            $newFavButton.append($("<img src='" + newIconUrl + "' />"));
            $newFavButton.append($("<span></span>").text(Utilities_1.synUtil.Strings.getValue("menuaddtofavorites")));
        }
        $buttonBar.append("<div style='clear: both;'></div>");
        $listViewTarget.kendoListView({
            autoBind: true,
            template: kendo.template(itemTemplate),
            selectable: "single",
            dataSource,
            dataBound() {
                let synData = $this.data("synFavorites");
                // Disable favorite button if readonly and no favorites exist
                let favData = this.dataSource.data();
                let hasFavorites = favData.length > 0;
                let $favMenu = $this.children("ul.favMenu");
                let kendoFavMenu = $this.children("ul.favMenu").data("kendoMenu");
                let enableMenu = !synData.readOnly || hasFavorites;
                if (kendoFavMenu)
                    kendoFavMenu.enable($favMenu.children("li.k-item"), enableMenu);
                $favMenu.toggleClass("favDisabled", !enableMenu);
                // Show some "no items" text if no favorites exist
                if (!hasFavorites)
                    $listViewTarget.append("<span class='noResults'>" + Utilities_1.synUtil.Strings.getValue("searchnoresults") + "</span>");
                Favorites.InitButtons($this);
                Favorites.InitContentEditableEvents($this);
                Favorites.UpdateStar($this);
                let defFavs = $.grep(favData, e => e.instance.items["cefavorite.isdefault"].value);
                let selectDefFavorite = defFavs.length > 0;
                if (!$this.data("initialSelectionPerformed")) {
                    $this.data("initialSelectionPerformed", true);
                    if (synData.initiallySelectedId)
                        selectDefFavorite = selectDefFavorite && !Favorites.trySelectFavorite($this, synData.initiallySelectedId);
                    if (selectDefFavorite)
                        Favorites.selectFavorite($this, defFavs[0].id.value);
                }
                $this.trigger("dataBound");
            },
            change() {
                if (!$listViewTarget.data("ignoreChangeEvent")) {
                    let lv = $listViewTarget.data("kendoListView");
                    let lastSelection = $listViewTarget.data("lastSelection");
                    let favModel = lv.dataItem(lv.select());
                    if (typeof favModel === "undefined" && typeof lastSelection !== "undefined") {
                        $this.trigger("selectionCleared");
                        $listViewTarget.removeData("lastSelection");
                    }
                    else if (typeof favModel !== "undefined" && favModel.instance.id.value !== lastSelection) {
                        let unsavedIdx = -1;
                        let unsavedDataItem = $.grep(lv.dataSource.data(), (dataItem, idx) => {
                            if (typeof dataItem._unsavedChanges !== "undefined") {
                                if (unsavedIdx === -1)
                                    unsavedIdx = idx;
                                return true;
                            }
                            return false;
                        });
                        let triggerChangeEvent = (selItem) => {
                            Favorites.RemoveUnsavedChanges($this);
                            $listViewTarget.data("lastSelection", selItem.instance.id.value);
                            Favorites.GetJSON(selItem.instance.id.valueAsString, (json) => {
                                $this.trigger("favoriteSelected", [selItem.instance.id.value, json, selItem.instance.items["cefavorite.isdefault"].value]);
                                if (synData.showFavoriteSelectedNotification) {
                                    let favDisplayName = Favorites.getItemDisplayName(selItem.instance);
                                    let msg = kendo.format(Utilities_1.synUtil.Strings.getValue("favoriteselected"), favDisplayName);
                                    Utilities_1.synUtil.Notifications.info(msg);
                                    Favorites.UpdateStar($this);
                                }
                            });
                        };
                        if (!unsavedDataItem.length)
                            triggerChangeEvent(favModel);
                        else if (window.confirm(kendo.format(Utilities_1.synUtil.Strings.getValue("favoritediscardunsavedchanges"), Favorites.getItemDisplayName(favModel.instance))))
                            triggerChangeEvent(favModel);
                        else
                            lv.select($(lv.element.children()[unsavedIdx]));
                    }
                }
            }
        });
        $this.trigger("initSuccess");
    }
    static getItemDisplayName(instance) {
        return instance.name.value ? "\"" + instance.name.value + "\"" : "(" + instance.items["cgdocument.docid"].value + ")";
    }
    static RemoveUnsavedChanges($this) {
        let lv = $this.find(".favListView").data("kendoListView");
        let hadSavedChanges = false;
        $.each(lv.dataSource.data(), (idx, item) => {
            if (item._unsavedChanges) {
                hadSavedChanges = true;
                delete item._unsavedChanges;
            }
        });
        if (hadSavedChanges)
            Favorites.refreshAndKeepSelection($this);
    }
    static InitButtons($this) {
        let synData = $this.data("synFavorites");
        let listView = $this.find(".favListView").data("kendoListView");
        $this.find("a.name").off("click").on("click", function () {
            listView.select($(this).closest("div.favorite"));
        });
        $this.find(".delLink").off("click").on("click", function () {
            let id = $(this).closest("div.favorite").attr("data-id");
            let $favMenu = $(this).closest("ul.favMenu").addClass("noClose");
            MethodManager_1.MethodManager.executeMethod("cefunc.24", [id], undefined, undefined, function () {
                listView.dataSource.read();
                $this.trigger("favoriteDeleted", [id]);
                $favMenu.removeClass("noClose");
                Favorites.UpdateStar($this);
            }, undefined);
        });
        $this.find(".saveLink").off("click").on("click", function () {
            let $link = $(this);
            if (!$link.hasClass("disabled")) {
                $link.addClass("disabled");
                let favModel = listView.dataItem(listView.select());
                if (favModel) {
                    let id = $link.closest("div.favorite").attr("data-id");
                    if (favModel.instance.id.value === id && favModel._unsavedChanges != undefined) {
                        Favorites.SetJSON(id, favModel._unsavedChanges, () => {
                            delete favModel._unsavedChanges;
                            Favorites.refreshAndKeepSelection($this);
                            let msg = kendo.format(Utilities_1.synUtil.Strings.getValue("favoritesaved"), Favorites.getItemDisplayName(favModel.instance));
                            Utilities_1.synUtil.Notifications.info(msg);
                            $this.trigger("favoriteContentChanged");
                        }, () => {
                            $link.removeClass("disabled");
                        });
                    }
                }
            }
        });
        $this.find(".writeLink")
            .off("click").on("click", function () {
            Favorites.EditName($this, $(this).next("div.wrapper").children("a.name"));
        });
        $this.find(".newFavButton").off("click").on("click", function () {
            let holder = { favorite: undefined };
            $(this).closest("ul.favMenu").addClass("noClose");
            $this.trigger("newFavoriteRequested", [holder]);
            if (holder.favorite) {
                Utilities_1.synUtil.getAJAXData({
                    method: "POST",
                    url: Utilities_1.synUtil.getWSUrl("ProfileFavorites") + synData.viewName,
                    requestData: JSON.stringify(holder.favorite),
                    done(newFav) {
                        return tslib_1.__awaiter(this, void 0, void 0, function* () {
                            let favModel = new FavoriteModel();
                            favModel.instance = yield Instance_1.Instance.fromJSON(newFav);
                            favModel.readOnly = synData.readOnly;
                            listView.dataSource.insert(0, favModel);
                            listView.dataSource.sync();
                            Favorites.RemoveUnsavedChanges($this);
                            let $newFav = listView.element.children().first();
                            listView.select($newFav);
                            Favorites.EditName($this, $newFav.find("a.name"));
                        });
                    }
                });
            }
            else
                $(this).closest("ul.favMenu").removeClass("noClose");
        });
    }
    static InitContentEditableEvents($this) {
        let synData = $this.data("synFavorites");
        let listView = $this.find(".favListView").data("kendoListView");
        $this.find("a.name")
            .off("focus").on("focus", function (e) {
            let $favMenu = $(this).closest("ul.favMenu");
            if ($(this).attr("contenteditable")) {
                $(this).data("origValue", $(this).text());
                if (synData.compact)
                    $favMenu.addClass("noClose");
            }
            else {
                if (synData.compact)
                    $favMenu.data("kendoMenu").close($favMenu.children("li"));
            }
        })
            .off("keyup").on("keyup", function (e) {
            if (e.which === 13)
                $(this).blur();
            else if (e.which === 27) {
                $(this).text($(this).data("origValue"));
                $(this).blur();
            }
        })
            .off("blur").on("blur", function () {
            let $elem = $(this);
            if (synData.compact)
                $(this).closest("ul.favMenu").removeClass("noClose");
            if ($elem.attr("contenteditable")) {
                $elem.removeAttr("contenteditable");
                let sanitizedText = $elem.text().replace(/\r?\n/g, " ");
                if (synData.maxNameLength !== 0 && sanitizedText.length > synData.maxNameLength)
                    sanitizedText = sanitizedText.substring(0, synData.maxNameLength);
                if ($elem.data("origValue") !== sanitizedText) {
                    let favModel = listView.dataItem($elem.closest("div.favorite"));
                    // Warum wird hier eine neue Instance angelegt? Vermutlich damit weniger Daten zum Server übertragen werden müssen. favModel.instance enthält die gesamte Instanz. Es muss aber lediglich der doclabel geändert werden.
                    let instanceNew = new Instance_1.Instance();
                    instanceNew.items["id"] = favModel.instance.id;
                    instanceNew.items["cgdocument.instanzid"] = favModel.instance.items["cgdocument.instanzid"].clone();
                    instanceNew.items["cgdocument.docid"] = favModel.instance.items["cgdocument.docid"].clone();
                    instanceNew.items["cgdocument.typeid"] = favModel.instance.items["cgdocument.typeid"].clone();
                    instanceNew.items["cgdocument.version"] = favModel.instance.items["cgdocument.version"].clone();
                    instanceNew.items["cgdocument.doclabel"] = favModel.instance.items["cgdocument.doclabel"].clone();
                    instanceNew.items["cgdocument.doclabel"].value = sanitizedText;
                    Utilities_1.synUtil.getAJAXData({
                        method: "POST",
                        url: Utilities_1.synUtil.getWSUrl("InstanceSave"),
                        requestData: { instance: JSON.stringify(instanceNew.toJSON()) },
                        done(data) {
                            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                                let lv = $elem.closest(".favListView").data("kendoListView");
                                let favModelNew = lv.dataItem($elem.closest("div.favorite"));
                                favModelNew.instance = yield Instance_1.Instance.fromJSON(data);
                                let msg = kendo.format(Utilities_1.synUtil.Strings.getValue("favoritesaved"), Favorites.getItemDisplayName(favModelNew.instance));
                                Utilities_1.synUtil.Notifications.info(msg);
                                $this.trigger("favoriteInstanceChanged", [instanceNew]);
                            });
                        },
                        fail(jqXHR, textStatus, errorThrown, url) {
                            $elem.text($elem.data("origValue"));
                            Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                        }
                    });
                }
            }
        });
    }
    static EditName($this, $nameField) {
        let synData = $this.data("synFavorites");
        $nameField
            .attr("contenteditable", "true")
            .off("paste").on("paste", function (evt) {
            evt.stopPropagation();
            evt.preventDefault();
        })
            .off("keydown").on("keydown", (evt) => {
            if ($(evt.target).text().length >= synData.maxNameLength && evt.keyCode !== 8 && evt.keyCode !== 46)
                evt.preventDefault();
            // Fix for accidental addition of <br> on enter to confirm new name
            if (evt.keyCode === 13) {
                $nameField.trigger("blur");
                evt.preventDefault();
            }
        });
        $nameField[0].focus();
        let sel;
        if (document.selection) {
            sel = document.selection.createRange();
            sel.select();
        }
        else {
            sel = window.getSelection();
            sel.collapse($nameField[0].firstChild, $nameField[0].firstChild.length);
        }
    }
    static SetJSON(id, jsObject, callback, cleanUpCallback) {
        Utilities_1.synUtil.getAJAXData({
            method: "POST",
            url: Utilities_1.synUtil.getWSUrl("ContentInstanceJSON") + id,
            requestData: JSON.stringify(jsObject),
            done: callback,
            cleanUp: cleanUpCallback
        });
    }
    static GetJSON(id, callback) {
        Utilities_1.synUtil.getAJAXData({
            url: Utilities_1.synUtil.getWSUrl("ContentInstanceJSON") + id,
            done: callback
        });
    }
    static UpdateStar($this) {
        let synData = $this.data("synFavorites");
        if (synData.compact) {
            let $star = $this.find(".menuStar");
            let lv = $this.find(".favListView").data("kendoListView");
            let dataItem = lv.dataItem(lv.select());
            if (dataItem) {
                $star.removeClass("fa-star-o").addClass("fa-star");
                if (dataItem._unsavedChanges)
                    $star.addClass("unsavedChanges");
                else
                    $star.removeClass("unsavedChanges");
            }
            else
                $star.removeClass("fa-star").addClass("fa-star-o");
        }
    }
}
(function ($) {
    $.fn.synFavorites = function (method) {
        if (Favorites[method])
            return Favorites[method].apply(undefined, [this].concat(Array.prototype.slice.call(arguments, 1)));
        else if (typeof method === "object" || !method)
            return Favorites.init(this, arguments[0]);
        else
            $.error("Method " + method + " does not exist on jQuery.synFavorites");
    };
})(jQuery);
